var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right my-3"},[_c('a',{staticClass:"link",attrs:{"href":"#/"},on:{"click":function($event){return _vm.deleteProject(_vm.project.id)}}},[_vm._v("Delete Project")])])
}
var staticRenderFns = []

export { render, staticRenderFns }